module.exports = ".p-0 {\n  padding: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.scss
// module id = ./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.scss
// module chunks = 0